import { hookstate } from "@hookstate/core";

import { LeadState } from "./pages/lead";
import { ISimulacaoState } from "./simulacao";

const globalState = hookstate({
    isLoading: true
} as {
    isLoading: boolean
    simulacaoState: ISimulacaoState
    leadState: LeadState
});

export default globalState;